import CrudRequest from '@rootCommon/services/crud-request';
import { FHQ_HELP_CONTACT } from '@rootCommon/constants/end-points';
import { ADMIN } from '@rootCommon/constants/common';
import { FhqHelpContact, FhqHelpContactCreateDto, FhqHelpContactUpdateDto } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

const FHQ_HELP_CONTACT_ADMIN = `${FHQ_HELP_CONTACT}/${ADMIN}`;
const FHQ_HELP_CONTACT_ADMIN_ALL = `${FHQ_HELP_CONTACT}/all/${ADMIN}`;

class FhqHelpContactsService extends CrudRequest<FhqHelpContact, FhqHelpContactCreateDto | FhqHelpContactUpdateDto> {
  constructor() {
    super(FHQ_HELP_CONTACT_ADMIN);
  }

  getListBySiteFhqId = async (siteFhqId: IdType): Promise<FhqHelpContact> => {
    const res = await CrudRequest.get<FhqHelpContact>(FHQ_HELP_CONTACT_ADMIN_ALL, {
      params: { siteFhqId },
    });

    return res.data;
  };
}

export default new FhqHelpContactsService();
